import { render } from "./StagePositionDeviceIdentity.vue?vue&type=template&id=d9cfc71a&scoped=true"
import script from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"
export * from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"

import "./StagePositionDeviceIdentity.vue?vue&type=style&index=0&id=d9cfc71a&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9cfc71a"]])

export default __exports__